module.exports = __webpack_public_path__ + "b1133f7054a8169f2dd6e77e70cfccc0.svg";